import React, {FC} from 'react';

import {SvgIconProps} from '@mui/material/SvgIcon';
import {Box, Typography} from '@mui/material';

type AurDismissBannerProps = {
  bannerHeading: string;
  bannerSummary?: string;
  icon?: React.ReactElement<SvgIconProps>;
  children?: React.ReactNode;
  bgColorClass?: string;
  className?: string;
  containerClassName?: string;
};
export const AurDismissBanner: FC<AurDismissBannerProps> = ({
  bannerHeading,
  bannerSummary,
  icon,
  children,
  bgColorClass,
  className,
  containerClassName,
}) => {
  return (
    <Box className={`aur-dismiss-banner color-bg-${bgColorClass} ${className}`}>
      <Box className={`aur-dismiss-banner_container ${containerClassName}`}>
        {icon && <Box className="aur-dismiss-banner_icon">{icon}</Box>}
        <Box className="aur-dismiss-banner_title-box">
          <Typography
            className="typo-text label1_size title-dismiss-banner"
            component="div"
            data-testid="banner-title"
          >
            {bannerHeading}
          </Typography>
          {bannerSummary && (
            <Typography
              component="div"
              className="typo-text body3_size color-mist-900"
              data-testid="banner-summary"
            >
              {bannerSummary}
            </Typography>
          )}
        </Box>
        {children}
      </Box>
    </Box>
  );
};
